import moment from 'moment';

// Service dates are calendar dates; parse the date part only so no timezone shifts the day
const toDay = (value) => (value ? moment(String(value).slice(0, 10), 'YYYY-MM-DD') : null);

export const formatAbsoluteDate = (value) => {
    const day = toDay(value);
    return day && day.isValid() ? day.format('MMM D, YYYY') : '';
};

// AB#17128 AC12: absolute plus relative, counted in calendar days ("Mar 1, 2026 · 412 days ago")
export const formatAbsRelDate = (value) => {
    const day = toDay(value);
    if (!day || !day.isValid()) return '';
    const days = moment().startOf('day').diff(day, 'days');
    let relative;
    if (days === 0) relative = 'today';
    else if (days > 0) relative = `${days.toLocaleString()} ${days === 1 ? 'day' : 'days'} ago`;
    else relative = `in ${Math.abs(days).toLocaleString()} ${days === -1 ? 'day' : 'days'}`;
    return `${day.format('MMM D, YYYY')} · ${relative}`;
};

export const formatPercent = (value, digits = 1) => (value === null || value === undefined ? '' : `${Number(value).toFixed(digits)}%`);

export const formatLbs = (value) => (value === null || value === undefined ? '' : `${Number(value).toLocaleString(undefined, { maximumFractionDigits: 2 })} lb`);
